import { FeatureFlag } from './feature-flag.model';

export const DEVICE_MANAGEMENT_FEATURE_FLAG = 'deviceManagementEnabled';
// TODO: align with backend on the final flag name for AMM (Advanced Material Management).
export const MATERIAL_MANAGEMENT_FEATURE_FLAG = 'materialManagementEnabled';

export const DEFAULT_FEATURE_FLAGS: FeatureFlag[] = [
    {
        name: DEVICE_MANAGEMENT_FEATURE_FLAG,
        active: false,
    },
    {
        name: MATERIAL_MANAGEMENT_FEATURE_FLAG,
        active: false,
    },
];
